import React from 'react';
import getUtcStringFromOffset from 'src/imports/getUtcStringFromOffset';
import Icon from 'antd/lib/icon';
import 'antd/lib/form/style/index.css';
import 'antd/lib/input/style/index.css';
import FormRoundItem from './FormRoundItem';
import ButtonAction from 'src/pages/components/utilities/ButtonAction';
var FormRound = function (props) {
    var rounds = props.rounds;
    var utcOffset = props.event.utcOffset;
    var timezoneDisplay = getUtcStringFromOffset(utcOffset);
    return (React.createElement(React.Fragment, null,
        rounds
            .sort(function (a, b) { return a.index - b.index; })
            .map(function (round, index) { return (React.createElement(FormRoundItem, { key: round.id || round.listKey, form: props.form, round: round, utcOffset: utcOffset, timezoneDisplay: timezoneDisplay, index: index, isLast: index === (rounds.length - 1), isDisabled: props.isDisabled, handleRemoveRound: props.handleRemoveRound })); }),
        React.createElement(ButtonAction, { isDisabled: props.isDisabled },
            React.createElement("a", { onClick: props.handleAddRound },
                React.createElement(Icon, { type: 'plus' }),
                "Add round into category"))));
};
export default FormRound;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormCategoryPage/FormRound/index.tsx
// module id = 1174
// module chunks = 0